module.exports = __webpack_public_path__ + "img/frederic-pro.885ec012.jpg";